// extracted by mini-css-extract-plugin
export default {"cursor":"Cursor_cursor__kea2W","ring":"Cursor_ring__ua7E7"};